export type AvatarCreationMode = "photo" | "video" | "prompt";

export interface PendingReferenceImage {
    assetId?: string;
    url?: string;
    previewUrl: string;
    fileName: string;
}

export interface WizardState {
    mode: AvatarCreationMode | null;
    name: string;

    // Photo / Video — exactly one of assetId/url is set after upload.
    assetId?: string;
    url?: string;
    sourcePreviewUrl?: string;
    videoDurationSec?: number;
    mediaError?: string;
    mediaWarning?: string;

    // Prompt mode.
    prompt: string;
    referenceImages: PendingReferenceImage[];
}

export const INITIAL_STATE: WizardState = {
    mode: null,
    name: "",
    prompt: "",
    referenceImages: [],
};
